<template>
  <div v-if="preferences.length > 0">
    <div class="ml-2 pb-4 text-h6">{{ $t('conflict.alreadyCreatedPreferences') }}</div>
    <v-list>
      <div
        v-for="(sw, index) in scenariosWithWigoList"
        :key="index"
      >
        <span class="caption" v-if="showDetails">
        {{ `Preference ${sw.preferenceId} / Scenario ${ sw.scenario.id } / level ${ sw.scenario.level }` }}
        </span>
        <v-list-item
        >
          <v-list-item-icon>
            <wigo-chip
              :wigo="sw.wigo[0]"
              class="mr-2"
            />
          </v-list-item-icon>
          <v-list-item-content>
            <scenario
              :scenario="filterElementsOfCurrentContext(sw.scenario.elements)"
              :show-details="false"
            />
          </v-list-item-content>
        </v-list-item>
      </div>
    </v-list>

  </div>
</template>

<script>
import Scenario from '@/components/global/Scenario'
import WigoChip from '@/components/global/WigoChip.vue'

import believeService from '@/services/believes.js';
import _ from 'lodash';

// todo: improvments possible: show logos ? pref or scenario id ? only show pref of scenarios with previousLevel Scenarios = current scenario ?
export default {
  name: 'CreatedPreferences',

  components: { Scenario, WigoChip },

  props: {
    preferences: {
      type: Array,
      required: true,
    },
    currentElements: {
      type: Array,
      required: true,
    },
    beliefMode: {
      type: Boolean,
      required: false,
      default: false,
    },
    showDetails: {
      type: Boolean,
      required: false,
      default: false,
    },
  },

  data () {
    return {
      currentElementsIds: [],
      scenariosWithWigoList: [],
    }
  },

  computed: {
  },

  methods: {
    filterElementsOfCurrentContext(elements) {
      let filtered = elements
        .filter(elt => !this.currentElementsIds.includes(elt.id));
      return { elements: filtered };
    },

    /**
     * returns deduplicates scenario&wigo list based on input PrefList
     * @return {scenario: scenario, wigo: option[]}[]
     */
    computeScenariosWithWigoList () {
      const scenariosWithWigo = this.preferences
      .map(pref => {
        return {
          preferenceId: pref.id,
          scenario: pref.scenario, 
          wigo: [ pref[this.wigoProperty()] ],
          isGroup: !!pref.groupId,
          lastModifiedDate: pref.lastModifiedDate
        }
      })

      const generateId = (sw) => `${sw.scenario.id}-${sw.wigo.map(o => o.id).sort().join(',')}` 
      return _.uniqWith(scenariosWithWigo, (sw1, sw2) => generateId(sw1) === generateId(sw2))
        .sort((p1,p2) => new Date(p2.lastModifiedDate) - new Date(p1.lastModifiedDate));
    },

    wigoProperty() {
      return believeService.wigoProperty(this.beliefMode);
    },
  },

  created () {
    // console.log('created - createdPreferences')
    this.currentElementsIds = this.currentElements.map(element => element.id)
    this.scenariosWithWigoList = this.computeScenariosWithWigoList()
    // console.log('created - createdPreferences', this.scenariosWithWigoList)
  }
};
</script>
<style scoped>
.v-application--is-ltr .v-list-item__action:first-child, .v-application--is-ltr .v-list-item__icon:first-child {
  margin-right: 0px !important;
}
.v-list-item__content > * {
  line-height: 1.5 !important;
}
</style>